import { Modal, Spinner } from "react-bootstrap";

type ProcessingModalProps = {
    show: boolean;
    message?: string;
};

export default function ModalProcessing({
    show,
    message = "Processando, aguarde...",
}: ProcessingModalProps) {
    return (
        <Modal
            show={show}
            backdrop="static"
            keyboard={false}
            centered
            contentClassName="text-center p-4"
        >
            <div className="d-flex justify-content-center align-items-center">

                <Spinner animation="border" role="status" className="" />
                <span className="ps-2">
                    <strong>{message}</strong>
                </span>
            </div>
        </Modal>
    );
}
